/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ISgiNewArrival containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum layout {
    carousel = 'carousel',
    grid = 'grid'
}

export interface ISgiNewArrivalConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    layout?: layout;
    allowBackNavigation?: boolean;
    imageSettings?: Msdyn365.IImageSettings;
    clientRender?: boolean;
    enableAffiliationBasedPricing?: boolean;
    className?: string;
    newArrivalAttrKeyName?: string;
    newArrivalDateAttrKeyName?: string;
    newArrivalRefinerName?: string;
    newArrivalRefinerLVSValue?: string;
}

export interface ISgiNewArrivalResources {
    priceFree: string;
    priceRangeSeparator: string;
    ratingAriaLabel: string;
    flipperNext: string;
    flipperPrevious: string;
    originalPriceText: string;
    currentPriceText: string;
    ratingCountAriaLabel: string;
    ratingCountAriaLabelSingleUser: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface ISgiNewArrivalProps<T> extends Msdyn365.IModule<T> {
    resources: ISgiNewArrivalResources;
    config: ISgiNewArrivalConfig;
    slots: {
        quickview: React.ReactNode[];
    };
}
